import apiClient from "./api";
const TELEFONO_API_BASE_URL = "/telefonos";
class TelefonosService {
  getTelefonos() {
    return apiClient.get(TELEFONO_API_BASE_URL);
  }
  agregarTelefono(telefono) {
    return apiClient.post(TELEFONO_API_BASE_URL, telefono);
  }
  updateTelefono(telefono, telefonoId) {
    return apiClient.put(TELEFONO_API_BASE_URL + "/" + telefonoId, telefono);
  }
  deleteTelefono(telefonoId) {
    return apiClient.delete(TELEFONO_API_BASE_URL + "/" + telefonoId);
  }
  async getTelefonosPorSucursal(sucursalId) {
    try {
      const response = await apiClient.get(`${TELEFONO_API_BASE_URL}/sucursal/${sucursalId}`,);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new TelefonosService();